var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobScatterHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#931F1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(302 201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.2 -76.1C141.7 -41.4 123.3 9.6 96.7 46.7C70 83.8 35 107 -2.4 108.4C-39.9 109.8 -79.7 89.4 -100.5 55.8C-121.2 22.1 -122.9 -24.9 -102.9 -61C-83 -97.1 -41.5 -122.3 5.9 -125.7C53.3 -129.1 106.7 -110.8 124.2 -76.1Z",
    stroke: "#F7760E",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(545 559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89 -50C108.3 -17.9 112 24.4 94.6 61.1C77.2 97.8 38.6 128.8 -5.3 131.9C-49.1 134.9 -98.3 110 -121.4 70C-144.5 30.1 -141.5 -25 -117 -60.1C-92.4 -95.2 -46.2 -110.3 -5.7 -107C34.8 -103.8 69.7 -82.1 89 -50Z",
    stroke: "#F7760E",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(851 332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.1 -65.1C123 -29.6 115.3 16.3 93.6 50.5C71.8 84.6 35.9 107.1 2.2 105.8C-31.5 104.5 -63 79.5 -78 49.3C-93 19 -91.5 -16.5 -75.8 -50.7C-60 -84.9 -30 -117.9 6.8 -121.8C43.6 -125.7 87.1 -100.6 105.1 -65.1Z",
    stroke: "#F7760E",
    fill: "none",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7 -48.6C100.2 -12.7 108.8 27.5 93.5 61.2C78.2 94.9 39.1 122 0.6 121.6C-37.9 121.3 -75.7 93.4 -97.2 56.2C-118.7 18.9 -123.8 -27.8 -104.9 -63.3C-85.9 -98.8 -43 -123.2 -6.2 -119.6C30.6 -116 61.1 -84.5 80.7 -48.6Z",
    stroke: "#F7760E",
    fill: "none",
    strokeWidth: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobScatterHaikei);
export default __webpack_public_path__ + "static/media/blob-scatter-haikei.fc1d0f34370895f0190ca749aa893d14.svg";
export { ForwardRef as ReactComponent };